import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconNameType } from '../../shared/icons/icon-name-type.enum';
import { IconComponent } from '../../shared/icons/icon.component';
import { GenericModalContext, ModalName, ModalService } from '../services/modal.service';
import { RoundIconComponent } from "../../shared/round-icon/round-icon.component";

export type BackdropAction = 'close' | 'redirect-root' | 'prevent' | 'custom';

export interface EnhancedGenericModalContext extends GenericModalContext {
  backdropAction?: BackdropAction;
  onBackdropClick?: () => void;
  showCloseButton?: boolean;
  customClass?: string;
  
  messageParts?: {
    beforeLink?: string;
    linkText?: string;
    afterLink?: string;
    linkAction?: () => void;
  };
}

@Component({
  selector: 'cwo-forced-choice-modals',
  standalone: true,
  imports: [IconComponent, CommonModule, RoundIconComponent],
  templateUrl: './forced-choice-modals.component.html',
  styleUrl: './forced-choice-modals.component.scss'
})
export class ForcedChoiceModalsComponent {
  modalService = inject(ModalService);

  iconNameType = IconNameType;

  get modalContext() {
    return this.modalService.stateForModal(ModalName.ForcedChoice) as EnhancedGenericModalContext | undefined;
  }

  handleLinkClick() {
    if (this.modalContext?.messageParts?.linkAction) {
      this.modalContext.messageParts.linkAction();
    }
  }


  secondaryAction() {
    let result;
    if (this.modalContext?.secondaryAction) {
      result = this.modalContext.secondaryAction();      
    }
    if (this.modalContext?.closeOnAction) {
      this.modalService.closeModal(ModalName.ForcedChoice, result);
    }
  }

  closeModal() {
    this.modalService.closeModal(ModalName.ForcedChoice);
  }

  confirmAction() {
    let result;
    if (this.modalContext?.primaryAction) {
      result = this.modalContext.primaryAction();      
    }
    if (this.modalContext?.closeOnAction) {
      this.modalService.closeModal(ModalName.ForcedChoice, result);
    }
  }
}
